import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { PAYMENT_METHODS } from '@config/payment-methods.config';
import { KIOSK_PAYMENT_METHOD_PICKER_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { KioskPaymentMethodPickerBlockScenarioContent } from '@front-platform/content-builder';
import { KioskPaymentMethodPickerStep } from '@shared/blocks/kiosk-payment-method-picker-block/kiosk-payment-method-picker-step-enum';

import {
  KIOSK_PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM,
  KioskPaymentMethodPickerBlockDataSource,
  KioskPaymentMethodPickerBlockViewModel,
} from './kiosk-payment-method-picker-block-view-model';

export function toKioskPaymentMethodPickerPreviewViewModel(
  content: KioskPaymentMethodPickerBlockScenarioContent,
): KioskPaymentMethodPickerBlockViewModel {
  return {
    headingChoosePaymentMethod: content.headingChoosePaymentMethod,
    choicePayOnSite: content.choicePayOnSite,
    choicePayOnKiosk: content.choicePayOnKiosk,
    terminalInstructionMessage: content.terminalInstructionMessage,
    payOnKioskText: content.payOnKioskText,
    displayPayOnKioskImage: content.displayPayOnKioskImage,
    payOnKioskImage: content.payOnKioskImage,
    order: content.order as unknown as KioskPaymentMethodPickerBlockViewModel['order'],
    availablePaymentMethods: PAYMENT_METHODS.filter(method =>
      content.availablePaymentMethodHandles.includes(method.handle),
    ),
    step:
      content.step === 'TERMINAL'
        ? KioskPaymentMethodPickerStep.TERMINAL
        : KioskPaymentMethodPickerStep.CHOICE,
  };
}

@Injectable()
export class KioskPaymentMethodPickerBlockPreviewDataSource implements KioskPaymentMethodPickerBlockDataSource {
  readonly vm$: Observable<KioskPaymentMethodPickerBlockViewModel | null> = previewScenarioForBloc$(
    KIOSK_PAYMENT_METHOD_PICKER_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return KIOSK_PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<KioskPaymentMethodPickerBlockScenarioContent>(
        scenario,
        KIOSK_PAYMENT_METHOD_PICKER_BLOCK_COMPONENT,
      );
      return content
        ? toKioskPaymentMethodPickerPreviewViewModel(content)
        : KIOSK_PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM;
    }),
  );
}
